import { getCanvasState } from '@components/ArtBoard/Canvas/helpers/canvas'
import {
  type DragEndEvent,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import type { BlockWireframe } from '@octopus-do/octopus-project-core'
import { useState } from 'react'

import { moveWireframe, wireframeItemId } from '../utils'

// A plain click stays a click: the drag starts once the pointer has moved.
const ACTIVATION_DISTANCE = 4

// The sorting of a block's wireframes: the row ids, the pointer sensor, the
// canvas scale at the moment the drag started and the reorder on drop.
export const useSortableWireframes = (
  wireframes: BlockWireframe[],
  onChange: (wireframes: BlockWireframe[]) => void
) => {
  const [scale, setScale] = useState(1)

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: ACTIVATION_DISTANCE },
    })
  )

  const items = wireframes.map(wireframeItemId)

  // The canvas keeps its zoom in the DOM transform, as the toolbars read it.
  const onDragStart = () => {
    setScale(
      getCanvasState(document.getElementById('gestureMovableContainer')).scale
    )
  }

  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (!over || active.id === over.id) {
      return
    }

    onChange(
      moveWireframe(
        wireframes,
        items.indexOf(String(active.id)),
        items.indexOf(String(over.id))
      )
    )
  }

  return { items, onDragEnd, onDragStart, scale, sensors }
}
